import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext } from '@eas/common-web';
import { AttachmentProvider } from '@composite/attachments/attachment-context';
import { Tabs } from '@composite/tabs/tabs';
import { TabsConfig } from '@composite/tabs/tabs-types';
import { Role } from '@enums';
import { Content } from './fields/content/content';
import { General } from './fields/general/general';
import { History } from './fields/history/history';
import { SenderFields } from './fields/sender/sender';
import { Validations } from './fields/validations/validations';

export function Fields() {
  const { hasPermission } = useContext(UserContext);

  const config: TabsConfig = [
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_DELIVERED__DETAIL__PANEL_TITLE__GENERAL"
          defaultMessage="Obecné"
        />
      ),
      key: 'GENERAL',
      content: <General />,
      validationKeys: ['deliveryDate', 'summary'],
    },
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_DELIVERED__DETAIL__PANEL_TITLE__CONTENT"
          defaultMessage="Obsah"
        />
      ),
      key: 'CONTENT',
      content: <Content />,
    },
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_DELIVERED__DETAIL__PANEL_TITLE__VALIDATION"
          defaultMessage="Validace"
        />
      ),
      key: 'VALIDATION',
      content: <Validations />,
    },
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_DELIVERED__DETAIL__PANEL_TITLE__SENDER"
          defaultMessage="Odesílatel"
        />
      ),
      key: 'SENDER',
      content: <SenderFields />,
    },
    ...(hasPermission(Role.ADMIN)
      ? [
          {
            label: (
              <FormattedMessage
                id="ES__DOCUMENT_DELIVERED__DETAIL__PANEL_TITLE__HISTORY"
                defaultMessage="Historie"
              />
            ),
            key: 'HISTORY',
            content: <History />,
          },
        ]
      : []),
  ];

  return (
    <AttachmentProvider>
      <Tabs config={config} />
    </AttachmentProvider>
  );
}
